"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconError = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/icon-error.svg"));
var _svbReactComponents = require("@svb/svb-react-components");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Error component Template
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 *
 * This component renders ErroPage Fallback UI
 * Props description added in readme
 */

const SVBErrorPage = props => {
  const {
    title = 'Something went wrong',
    errorMessage = {
      statusCode: 'javascript',
      errorStatusMessages: {}
    },
    defaultErrorMessage = 'It happens sometimes, you may refresh the page or go to home.',
    icon = _iconError.default,
    enableButton = true,
    buttonText = 'Go Home',
    handleButtonClick,
    overrideContainerStyle = 'error-template-container',
    overrideElementStyle = 'position-absolute top-50 start-50 translate-middle'
  } = props;
  const ErrorStatusMessagesLists = errorMessage !== null && errorMessage !== void 0 && errorMessage.errorStatusMessages && (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.errorStatusMessages.length) > 0 ? errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.errorStatusMessages : {
    400: 'Bad Request',
    401: 'Unauthorized',
    403: 'Forbidden',
    404: 'Page Not Found',
    408: 'Request Time-Out',
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Service Temporarily Overloaded',
    503: 'Service Unavailable',
    504: 'Gateway Timeout',
    505: 'HTTP Version not supported'
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "error-page-component",
    className: overrideContainerStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: overrideElementStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: icon,
    className: "img-fluid",
    alt: "error-page-icon"
  }), /*#__PURE__*/_react.default.createElement("h2", {
    className: "heading-medium-large fw-300 pt-3 font-family-roboto"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph"
  }, ErrorStatusMessagesLists[errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.statusCode] ? "".concat(errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.statusCode, " ").concat(ErrorStatusMessagesLists[errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.statusCode], ". ").concat(defaultErrorMessage) : defaultErrorMessage), enableButton && /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBButton, {
    extraClasses: "paragraph font-family-roboto api-consumer-header-font-other-bg px-5 p-0 m-0",
    text: buttonText,
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    onClick: handleButtonClick
  }))));
};
var _default = exports.default = SVBErrorPage;
SVBErrorPage.propTypes = {
  title: _propTypes.default.string,
  errorMessage: _propTypes.default.object,
  defaultErrorMessage: _propTypes.default.string,
  icon: _propTypes.default.string,
  enableButton: _propTypes.default.bool,
  buttonText: _propTypes.default.string,
  handleButtonClick: _propTypes.default.func,
  overrideContainerStyle: _propTypes.default.string,
  overrideElementStyle: _propTypes.default.string
};